import { render } from "./ScanCounterfeitView.vue?vue&type=template&id=a8f50bea&scoped=true&lang=true"
import script from "./ScanCounterfeitView.vue?vue&type=script&lang=js"
export * from "./ScanCounterfeitView.vue?vue&type=script&lang=js"

import "./ScanCounterfeitView.vue?vue&type=style&index=0&id=a8f50bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f50bea"]])

export default __exports__